// I pannelli del layout (assistente, guida di benvenuto) non si toccano in un refresh con morph della stessa pagina
// (verifica/show, bandi/index): turbo:before-morph-element sul loro elemento radice viene annullato, così la finestra
// aperta e la conversazione restano. Uso: data-action="turbo:before-morph-element->nome#conserva" e
// `conserva(event) { conservaDalMorph(this.element, event) }`.
export function conservaDalMorph(radice, event) {
  if (event.target === radice) event.preventDefault()
}
